import { render, staticRenderFns } from "./addbank.vue?vue&type=template&id=cd134a74&"
import script from "./addbank.vue?vue&type=script&lang=js&"
export * from "./addbank.vue?vue&type=script&lang=js&"
import style0 from "./addbank.vue?vue&type=style&index=0&id=cd134a74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports